// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3Ww38","text":"SelectPayment_text__1mx4T","title":"SelectPayment_title__3d7rh","btn":"SelectPayment_btn__1yvFD"};